import React, { FC } from 'react';
import { FunctionField } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { JobMasterSheetInterface } from '@vatos-pas/common';

const useStyles = makeStyles({
  suggestedContractor: {
    color: '#646466',
  },
});

interface PhaseContractorFieldProps {
  label?: string;
}

export const PhaseContractorField: FC<PhaseContractorFieldProps> = ({
  label = 'Phase Contractor',
  ...props
}) => {
  const classes = useStyles();

  return (
    <FunctionField<JobMasterSheetInterface>
      {...props}
      label={label}
      render={record => {
        if (record?.currentPhaseContractorName) {
          return (
            <Typography variant="body2">
              {record.currentPhaseContractorName}
            </Typography>
          );
        }

        if (record?.currentPhaseSuggestedContractorName) {
          return (
            <Typography
              variant="body2"
              className={classes.suggestedContractor}
              title="Suggested Contractor"
            >
              {record.currentPhaseSuggestedContractorName}
            </Typography>
          );
        }

        return null;
      }}
    />
  );
};
